import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ApiCallingService } from "../../services/api-calling.service";
import { ConfigApi } from "../../config-api";
import { Globals } from "../../common/global";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-beach-booking",
  templateUrl: "./beach-booking.component.html",
  styleUrls: ["./beach-booking.component.css"],
})
export class BeachBookingComponent implements OnInit {
  beachBookings: any = [];
  @ViewChild("deleteBeachModal") deleteBeachModal: any;
  deleteModalId: number | string = "";
  page: number = 0;
  pageSize: number = 10;
  totalcount: number = 0;
  operator_id!: string;
  operatorDetails: Object = {};
  ListDetails: any[] = [];
  details: any;

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private apiCallingService: ApiCallingService,
    public Globals: Globals,
    private toastr: ToastrService
  ) {}
  ngOnInit(): void {
    this.operator_id = this.Globals.getUser()._id;
    this.operatorDetails = this.Globals.getOperatorDetails();
    this.getList();
  }

  getList(): void {
    let page = this.page == 0 ? 0 : this.page - 1;

    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.SPOT_BOOKING.LIST +
          "?operator_id=" +
          this.operator_id +
          "&page=" +
          page +
          "&limit=" +
          this.pageSize
      )
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.beachBookings = res.data.data;
            this.totalcount = res.data?.total;
          } else {
            console.error(res.msg);
          }
        },
        (err) => {
          this.toastr.error(err.error.msg, "Error");
        }
      );
  }

  editBooking(bookingId: number): void {
    this.router.navigate(["/user/spot-booking/edit", bookingId]);
  }

  deleteBooking(bookingId: number): void {
    this.modalService.open(this.deleteBeachModal, {
      centered: true,
      backdrop: "static",
    });

    this.deleteModalId = bookingId;
  }

  viewBookingDetails(bookingId: number): void {
    this.router.navigate(["/user/spot-booking/details", bookingId]);
  }

  removeBeach(id: number): void {
    this.apiCallingService
      .callAPI({}, "DELETE", ConfigApi.URLS.SPOT_BOOKING.DELETE + "/" + id)
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.ngOnInit();
            this.toastr.success(res.msg);
            this.modalService.dismissAll();
          }
        },
        (err) => {
          this.ngOnInit();
          this.modalService.dismissAll();
          this.toastr.error(err.error.msg, "Error");
        }
      );
  }
  getAvailableSlots(slots: any[]): number {
    return slots?.filter((slot) => slot.status === "available").length || 0;
  }
  getBookedSlots(slots: any[]): number {
    return slots?.filter((slot) => slot.status === "booked").length || 0;
  }
  loadPage(page: number) {
    if (page) {
      this.page = page;
      this.getList();
    }
  }
}
